import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";
export default function getContainerIds() {
  var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return containers.reduce(function (mappedContainers, container) {
    mappedContainers[container.name] = true;
    return mappedContainers;
  }, {});
}